// eslint-disable-next-line canonical/filename-match-exported
import {
  Grid,
  GridItem,
  Hr,
  List,
  ListItem,
  Paragraph,
  Text,
} from '@constellation/core';
import {Clock, Mouse, Tick} from '@constellation/core/icons';
import {memo, useCallback} from 'react';
import {
  JOURNEY_EVENT,
  LINK_VALUE,
  TAGGING_FIELDS,
} from '../../../../../enums/tagging/index.js';
import {getPsrLabel} from '../../../../../utils/index.js';
import {QuoteSummaryButtons} from '../../../../common/Analytics/Tagging/index.js';
import {CallToActionWrapper, ClockWrapper} from '../Styles/Styles.js';

const CallToActionGuideLine = memo(() => {
  const handleApplyClick = useCallback(() => {
    window.open(
      getPsrLabel(
        'cardPaymentServicesDetails.callToActionGuideLines.applicationJourneyLink'
      ),
      '_self'
    );
  }, []);
  const listItems = getPsrLabel(
    'cardPaymentServicesDetails.callToActionGuideLines.criteriaList'
  );

  return (
    <CallToActionWrapper bgColor='neutral2' marginTop='04'>
      <Mouse color='brand' iconSize='lg' size='s3' />{' '}
      <Text size='s4'>
        {getPsrLabel(
          'cardPaymentServicesDetails.callToActionGuideLines.titleText'
        )}
      </Text>
      <Hr marginBottom='04' marginTop='04' />
      <List marginBottom='05'>
        <ListItem
          icon={<Tick color='success' iconSize='md' trim={true} />}
          key={listItems[0].id}
        >
          {listItems[0].description}
        </ListItem>
        <ListItem
          icon={<Tick color='success' iconSize='md' trim={true} />}
          key={listItems[1].id}
        >
          {listItems[1].description}
        </ListItem>
        <ListItem
          icon={<Tick color='success' iconSize='md' trim={true} />}
          key={listItems[2].id}
        >
          {listItems[2].description}
        </ListItem>
        <ListItem
          icon={<Tick color='success' iconSize='md' trim={true} />}
          key={listItems[3].id}
        >
          {listItems[3].description}
        </ListItem>
        <ListItem
          icon={<Tick color='success' iconSize='md' trim={true} />}
          key={listItems[4].id}
        >
          {listItems[4].description}
        </ListItem>
      </List>
      <Paragraph marginBottom='04'>
        {getPsrLabel('cardPaymentServicesDetails.callToActionGuideLines.note')}
      </Paragraph>
      <Grid alignY='center'>
        <GridItem lg={3} md={12}>
          <QuoteSummaryButtons
            eventAction={JOURNEY_EVENT.PAGE_SUBMIT}
            fieldName={TAGGING_FIELDS.APPLY_NOW}
            journeyEvent={JOURNEY_EVENT.INTERNAL_CLICK}
            linkValue={LINK_VALUE.applynow}
            taggingLabel={TAGGING_FIELDS.APPLY_NOW}
            variation='primary'
            width='fluid'
            onClick={handleApplyClick}
          >
            {getPsrLabel(
              'cardPaymentServicesDetails.callToActionGuideLines.ctaLabel'
            )}
            <span
              aria-label={getPsrLabel(
                'cardPaymentServicesDetails.callToActionGuideLines.ctaLabelSrText'
              )}
            />
          </QuoteSummaryButtons>
        </GridItem>
        <GridItem lg={9} md={12}>
          <ClockWrapper>
            <Clock color='brand' iconSize='lg' size='s1' />{' '}
            <Text marginLeft='02' size='s2'>
              {getPsrLabel(
                'cardPaymentServicesDetails.callToActionGuideLines.clockText'
              )}
            </Text>
          </ClockWrapper>
        </GridItem>
      </Grid>
    </CallToActionWrapper>
  );
});

export default CallToActionGuideLine;
